import * as React from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import Store from './store';
import BacktopFooter from '@src/business-components/backtop-footer';
const styles = require('./index.less');

const NewsDetail = ({ store }) => {
  store.use();

  return (
    <Page className={cx(styles.root, store.isActive && xauCss.AOS_ROOT)}>
      <div className={styles.container}>
        <div className={cx(styles.btnBack, { ...xauCss.AOS_FADE.IN_RIGHT.FAST_DELAY(1) })}>
          <Button className={styles.btnBackInner} onClick={store.back} />
        </div>
        <div id="content" className={styles.inner}>
          <h2 className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}>{store.article_title}</h2>
          <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(2) })} />
          <div className={cx(styles.date, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {/* <span className={styles.tag}>{store.categoryName}</span> */}
            {dayjs(store.date * 1000).format('YYYY/MM/DD')}
          </div>
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })} dangerouslySetInnerHTML={{ __html: store?.content }} />
        </div>
        <BacktopFooter />
      </div>
    </Page>
  );
};

export default wrapStore(NewsDetail, Store);
